import React from "react"
import { useSelectionProvider } from "../fmanlibs/SelectionProvider"
import Button from "../gui/Button/Button"
import MenuButton from "../gui/Menu/MenuButton"
import useFileShare from "../fmanlibs/FileShare"
import { FMFile } from "../shared/FMFile"
import useDeleteFiles from "../fmanlibs/useDeleteFiles"
import useRenameDlg from "./Rename/RenameDlg"
import { useNewFileDlg } from "./New/NewFileDlg"
import { useFilesProvider } from "../fmanlibs/FilesProvider"
import AddIcon from "../gui/Icons/AddIcon"
import FolderIcon from "./Icons/FolderIcon"
import EditIcon from "../gui/Icons/EditIcon"
import DeleteIcon from "../gui/Icons/DeleteIcon"
import ShareIcon from "../gui/Icons/ShareIcon"
import PhotoIcon from "./Icons/PhotoIcon"
import DocumentIcon from "./Icons/DocumentIcon"
import Measure from "../gui/Measure/Measure"
import MenuIcon from "../gui/Icons/MenuIcon"
import { TMenuRow } from "../gui/Menu/Menu"

export default function MainToolbar(){
    const {selected} = useSelectionProvider()
    const {getShare} = useFileShare()
    const {deleteFiles} = useDeleteFiles()
    const {rename} = useRenameDlg()
    const {openNewFile} = useNewFileDlg()
    const {root} = useFilesProvider()
    
    const onDelete = () => deleteFiles(selected)
    const onRename = () => rename(selected[0])
    const canPreview = selected.length==1 && FMFile.canPreview(selected[0])
    const canRename = selected.length==1
    const onNewFile = () => openNewFile(root!._id, true)
    const onNewDir = () => openNewFile(root!._id, false)
    const newOptions = [
        {id:"file",text:"File",icon:<DocumentIcon/>,onClick:onNewFile},
        {id:"dir",text:"Directory",icon:<FolderIcon/>,onClick:onNewDir},
    ]
    const onPreview = () => {}
    const buttons = [
        <MenuButton key="new" size="small" variant="outlined" menuProps={{options:newOptions}} disabled={!root}><AddIcon/><span>New</span></MenuButton>,
        <Button key="preview" size="small" variant="outlined" disabled={!canPreview}><PhotoIcon/><span>Preview</span></Button>,
        <Button key="rename" size="small" variant="outlined" disabled={!canRename} onClick={onRename}><EditIcon/><span>Rename</span></Button>,
        <Button key="delete" size="small" variant="outlined" disabled={selected.length==0} onClick={onDelete}><DeleteIcon/><span>Delete</span></Button>,
        <MenuButton key="share" size="small" menuProps={{options:getShare(selected)}} variant="outlined" disabled={selected.length==0}><ShareIcon/><span>Share</span></MenuButton>,
    ]
    const menuOptions : TMenuRow<string>[] = [{id:"new",text:"New",icon:<AddIcon/>,children:newOptions}]
    canPreview && menuOptions.push({id:"preview", text:"Preview", icon:<PhotoIcon/>, onClick:onPreview})
    canRename && menuOptions.push({id:"rename", text:"Rename", icon:<EditIcon/>, onClick:onRename})
    selected.length && menuOptions.push({id:"delete", text:"Delete", icon:<DeleteIcon/>, onClick:onDelete})
    selected.length && menuOptions.push({id:"share", text:"Share", icon:<ShareIcon/>, children:getShare(selected)})
    return <Measure id="toolbar">
        <MenuButton className="menu-button p-8" size="medium" menuProps={{options:menuOptions}}><MenuIcon/></MenuButton>
        {buttons}
    </Measure>
}